import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// تنسيق الأرقام بالإنجليزية
export function formatNumber(number) {
  return new Intl.NumberFormat('en-US').format(number)
}

// تنسيق المبالغ كأرقام فقط (بدون رمز عملة)
export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount || 0)
}

// تنسيق التاريخ بالأرقام الإنجليزية - DD/MM/YYYY
export function formatDate(date) {
  if (!date) return 'غير متوفر'
  
  const dateObj = new Date(date);
  
  // Check if date is valid
  if (isNaN(dateObj.getTime())) {
    return 'غير متوفر';
  }
  
  // Format as DD/MM/YYYY
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = String(dateObj.getFullYear());
  
  return `${day}/${month}/${year}`;
}

// تنسيق التاريخ المختصر بالأرقام الإنجليزية - DD/MM/YYYY
export function formatShortDate(date) {
  if (!date) return 'غير متوفر';
  
  const dateObj = new Date(date);
  
  // Check if date is valid
  if (isNaN(dateObj.getTime())) {
    return 'غير متوفر';
  }
  
  // Format as DD/MM/YYYY
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = String(dateObj.getFullYear());
  
  return `${day}/${month}/${year}`;
}

// تحويل النص لأرقام إنجليزية (Arabic-Indic + Persian)
export function toEnglishDigits(str) {
  if (str == null) return str
  const digitMap = {
    '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
    '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
    '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
    '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
  }
  return String(str).replace(/[٠-٩۰-۹]/g, (match) => digitMap[match] ?? match)
}

// تحويل النص لأرقام عربية (مع الإبقاء على الدالة للتوافق العكسي)
export function toArabicDigits(str) {
  // تم تعطيل التحويل - سيتم إرجاع الأرقام الإنجليزية
  return str.toString()
}

// دالة لحساب الإجمالي
export function calculateTotal(items, field) {
  return items.reduce((total, item) => total + (Number(item[field]) || 0), 0)
}

// دالة للبحث في النصوص العربية
export function searchArabicText(text, searchTerm) {
  if (!text || !searchTerm) return false
  
  const normalizedText = text.toLowerCase().trim()
  const normalizedSearch = searchTerm.toLowerCase().trim()
  
  return normalizedText.includes(normalizedSearch)
} 